<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link> >
            <router-link :to="'/atencionform/' + datoInterconsulta.idAtencion">Atención {{ p_numeroAtencion }}</router-link> >
            <router-link :to="'/atencion_interconsulta/' + datoInterconsulta.idAtencion + '/' + p_estadoAtencion + '/' + p_numeroAtencion">Interconsultas</router-link> 
            > {{ datoInterconsulta.especialidad }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">

      <form>
        <b>Datos de la Atención</b>
        <div class="modal-body">
<!-- Botón Lista de Valores  Persona -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="nombrePaciente" class="form-label">Paciente</label>
                  </div>
                  <div class="col-5">
                    <input type="text" class="form-control" id="nombrePaciente" name="nombrePaciente" v-model="datoAtencion.nombrePaciente" disabled>
                  </div>
                  <div class="col-1">
                    <label for="motivo" class="form-label">Cédula</label>
                  </div>
                  <div class="col-2">
                    <input type="text" class="form-control" id="motivo" name="motivo" v-model="datoAtencion.documentoPaciente" disabled>
                  </div>
                  <div class="col-1">
                    <label for="tipo" class="form-label">Tipo</label>
                  </div>
                  <div class="col-2">
                    <select class="form-control" id="tipo" name="tipo" v-model="datoAtencion.tipo" disabled>
                      <option value="I">Inicial</option>
                      <option value="S">Subsecuente</option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Medico -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="nombreMedico" class="form-label"> Médico</label>
                  </div>
                  <div class="col-5">
                    <input type="text" class="form-control" id="nombreMedico" name="nombreMedico" v-model="datoAtencion.nombreMedico" disabled>
                  </div>
                  <div class="col-1">
                    <label for="nombreEspecialidad" class="form-label">Especial.</label>
                  </div>
                  <div class="col-5">
                    <input type="text" class="form-control" id="nombreEspecialidad" name="nombreEspecialidad" v-model="datoAtencion.nombreEspecialidad" disabled>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medico -->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-5">
                  <textarea class="form-control" id="motivo" name="motivo" v-model="datoAtencion.motivo" style='text-transform:uppercase' disabled></textarea>
                </div>
                <div class="col-1">
                  <label for="observacion" class="form-label">Obs.</label>
                </div>
                <div class="col-5">
                  <textarea class="form-control" id="observacion" name="observacion" v-model="datoAtencion.observacion" style='text-transform:uppercase' disabled></textarea>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label">Id. Atención</label>
                    <input type="text" class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtencion.idAtencion" disabled>
                  </div>
                  <div class="col-5">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                    <input type="text" class="form-control" id="fechaReg" name="fechaReg" :value="getFormattedDate(datoAtencion.fechaReg)" disabled>
                  </div>
                  <div class="col-5">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                    <input type="text" class="form-control" id="fechaAct" name="fechaAct" :value="getFormattedDate(datoAtencion.fechaAct)" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </form>

      <hr>

      <form>
        <b>Datos de la Interconsulta</b>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInterconsulta.idInterconsulta" disabled>
                </div>
              </div>
            </div>
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoInterconsulta.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="especialidad" class="form-label">Especialidad</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoInterconsulta.especialidad" disabled>                    
                </div>
                <div class="col-1">
                  <label for="medico" class="form-label">Médico</label>
                </div>
                <div class="col-5">
                  <input type="text" class="form-control" id="medico" name="medico" v-model="datoInterconsulta.medico" disabled>                    
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="motivo" class="form-label">Motivo</label>
                </div>
                <div class="col-11">
                  <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo" disabled></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="cuadro" class="form-label">Cuadro</label>
                </div>
                <div class="col-11">
                <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" disabled></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
<!--
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarInterconsulta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInterconsulta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
-->
    </div>
  </div>

    <div class="mb-3">
      <div class="row">
        <div class="col-md-3">
        </div>
        <div class="col-md-3">

          <Modal v-model:modelValue="showModalSolicitud" title="Formulario 007 - Solicitud">
            <DocVerFirmarGuardar :idReporte="3"
                                :idDocumento="datoInterconsulta.idInterconsulta"/>
          </Modal>
          <button type="button"
                  class="btn btn-light"
                  @click="showModalSolicitud = true"
                  title="Formulario 007 - Solicitud">
            <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">
              quick_reference_all
            </span>
            Formulario 007 - Solicitud
          </button>
        </div>
        <div class="col-md-3">
          <Modal v-model:modelValue="showModalInforme">
            <DocVerFirmarGuardar :idReporte="4"
                                :idDocumento="datoInterconsulta.idInterconsulta"/>
          </Modal>
          <button type="button"
                  class="btn btn-light"
                  @click="showModalInforme = true"
                  title="Formulario 007 - Informe" 
                  :disabled="datoInterconsulta.estadoInter !== 'FINALIZADA'">
            <span class="material-symbols-outlined" 
                  :style="{ fontSize: '32px', color: datoInterconsulta.estadoInter !== 'FINALIZADA' ? 'gray' : 'green', cursor: 'pointer' }">
              quick_reference_all
            </span>
            Formulario 007 - Informe
          </button>
        </div>
        <div class="col-md-3">
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DocVerFirmarGuardar from '../utils/DocVerFirmarGuardar.vue';
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
//import swal from  'sweetalert'
export default {
  props: {
    p_numeroAtencion:   { type: String, required: true },
    p_estadoAtencion:   { type: String, required: true },
    p_idInterconsulta:  { type: Number, required: true },
  },
  components : {
    Layout, Footer, DocVerFirmarGuardar
  },
  data () {
    return {
      datoAtencion : {},
      interconsultas : [],
      datoInterconsulta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      showTable: 'biomAten', // Pestaña por defecto
      showModalHelp: false,
      showModalSolicitud: false,
      showModalInforme: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getDataAtencion(idAtencion){
      this.modalWindow = true
      if(idAtencion != null){    
           api.get('/vwatencions/'+idAtencion).then(resp=>{
          this.datoAtencion = resp.data;
           });
      }
      this.titulo   = 'Editar Interconsulta'
      this.btnCrear = false
      this.btnEditar= true
    }, 
   getData() {
      api.get('/vwinterconsultas/'+this.p_idInterconsulta)
        .then(response => {
          this.datoInterconsulta = response.data;
          this.getDataAtencion(this.datoInterconsulta.idAtencion)

        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
/*	
    formulario007solicitudPDF() {
      const url = 'http://localhost:8080/api/v1/reportes/pdf/3/' + this.p_idInterconsulta;
      window.open(url, '_blank');
    },
    formulario007informePDF() {
      const url = 'http://localhost:8080/api/v1/reportes/pdf/4/' + this.p_idInterconsulta;
      window.open(url, '_blank');
    },
*/

  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>